var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "online"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00016 1.33337C4.32683 1.33337 1.3335 4.32671 1.3335 8.00004C1.3335 11.6734 4.32683 14.6667 8.00016 14.6667C11.6735 14.6667 14.6668 11.6734 14.6668 8.00004C14.6668 4.32671 11.6735 1.33337 8.00016 1.33337ZM11.1868 6.46671L7.40683 10.2467C7.3135 10.34 7.18683 10.3934 7.0535 10.3934C6.92016 10.3934 6.7935 10.34 6.70016 10.2467L4.8135 8.36004C4.62016 8.16671 4.62016 7.84671 4.8135 7.65337C5.00683 7.46004 5.32683 7.46004 5.52016 7.65337L7.0535 9.18671L10.4802 5.76004C10.6735 5.56671 10.9935 5.56671 11.1868 5.76004C11.3802 5.95337 11.3802 6.26671 11.1868 6.46671Z",
    fill: "#29CD3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.9b0ac2de382fb2776f2490c9c4844154.svg";
export { ForwardRef as ReactComponent };